export default __webpack_public_path__ + "static/media/TVUlogo.bea4b5e4.png";